import React from 'react';

import type { Asset } from '@/types';

interface AssetRiskScoreCellProps {
  asset: Asset;
}

export const AssetRiskScoreCell: React.FC<AssetRiskScoreCellProps> = ({
  asset,
}) => {
  const score =
    typeof asset.riskScore === 'number' ? Math.max(1, asset.riskScore) : 1;
  return <span className="tabular-nums">{score}</span>;
};
